import locationStreetCityCountryModelValidator from 'forms/shared/validators/models/location/models/streetCityCountry';
import foreignCoOwnersModel from 'forms/sections/foreign/activities/shared/foreignCoOwners';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { REQUIRED, SOLD_DATE_TOO_EARLY } from 'constants/errors';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { ForeignActivitiesRealEstateItemModel } from '../types';

export const foreignActivitiesRealEstateItemValidator: ValidateJSModel<ForeignActivitiesRealEstateItemModel> = {
  InterestTypes: {
    presence: true,
    array: {
      validator: { presence: true },
      length: { minimum: 1, message: REQUIRED },
    },
  },

  RealEstateType: { hasValue: true },

  Address: {
    presence: true,
    location: {
      validator: locationStreetCityCountryModelValidator,
      excludeUnitedStates: true,
    }
  },

  Acquired: (value, attributes, attributeName, options) => {
    const { relationshipsOldestBirthdate } = options;

    return {
      presence: true,
      date: {
        requireYear: false,
        earliest: relationshipsOldestBirthdate,
        tooEarly: 'foreign.activities.realestate.interest.help.purchaseDate',
      },
    };
  },

  HowAcquired: { hasValue: true },

  Cost: {
    presence: true,
    model: { validator: currencyModelValidator },
  },

  Sold: (value, attributes) => {
    if (attributes?.SoldNotApplicable?.applicable === false) { return {}; }

    return {
      presence: true,
      date: {
        earliest: attributes?.Acquired,
        tooEarly: SOLD_DATE_TOO_EARLY,
        latest: DEFAULT_LATEST,
      },
    };
  },

  CoOwners: {
    presence: true,
    model: {
      validator: foreignCoOwnersModel,
    },
  },

  CostEstimated: {},

  SoldNotApplicable: {},
};
